import styled, { css } from 'styled-components';
import {
  alignItemsFlexStart,
  flexBoxCenter,
  justifyContentFlexEnd,
  justifyContentSpaceBetween,
  layerA,
  layerA90Deg,
  layerADark,
} from '../styles/commonStyles';

export const Wrapper = styled.div`
  min-height: 674px;
  width: 1216px;
`;

export const MainSectionBaseLayer = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 332px;
          height: auto;
          border-radius: 30px 30px 12px 12px;
        `
      : css`
          width: 1216px;
          height: auto;
          margin-top: 10rem;
          border-radius: 14px;
        `}

  padding: 2rem;
  ${layerADark}

  ${flexBoxCenter}
`;

export const MainSectionWrapper = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 326px;
          height: auto;
          border-radius: 28px 28px 10px 10px;
        `
      : css`
          width: 1212px;
          height: auto;
          border-radius: 12px;
        `}

  ${layerA90Deg}

  ${flexBoxCenter};
  flex-direction: column;
`;

export const WrapperTitle = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          margin-top: 5px;
          margin-bottom: 4px;
        `
      : css`
          width: 1202px;
          height: 70px;
          margin-top: 4rem;
          margin-left: 2rem;
          ${layerA}

          border-radius: 7px;
        `}
`;

export const WrapperSettingsModeAndSelect = styled.div`
  width: 1202rem;
  height: auto;
  margin-top: 8rem;
  ${alignItemsFlexStart}
  gap:15rem;
`;

export const FlexColumn = styled.div`
  display: flex;
  ${({ isSpaceBetween, isSmallSpaceBetween }) =>
    isSpaceBetween
      ? css`
          height: 498rem;
          ${justifyContentSpaceBetween}
        `
      : isSmallSpaceBetween &&
        css`
          height: 386rem;
          ${justifyContentSpaceBetween}
        `}
  flex-direction: column;
`;

export const ButtonsWrapper = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 100%;
          ${flexBoxCenter}
        `
      : css`
          width: 100%;
          ${({ isUserProfile }) =>
            isUserProfile &&
            css`
              margin-bottom: 2px;
            `}
          ${justifyContentFlexEnd}
        `}
`;

export const WrapperSetting = styled.div``;
